module.exports = __webpack_public_path__ + "static/media/placeholder.ad788cae.svg";